import React from 'react';
import HelloAppH5Page from '../hello-app-h5/common/HelloAppH5Page';

const HelloSellerAppH5Page: React.FC = () => (
  <HelloAppH5Page
    role="seller"
    documentTitle="打开圆领之家"
    buttonLabel="打开圆领之家"
    backgroundImageUrl={`${process.env.PUBLIC_URL}/seller_h5_bg.jpg`}
    placeholderBackgroundColor="#121a21"
    buttonBackgroundColor="#FFDA86"
    buttonTextColor="#1a1a1a"
  />
);

export default HelloSellerAppH5Page;
